import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BaseService } from './base.service';
import { BaseResponse 
    , ICRewardsList
    , RedeemReward
    , BaseRequest} from "../model/ifcapp.models";

@Injectable()
export class IFCAppServices extends BaseService {
    async getRewardList(request/*,  options?:{language?: string}*/) {
        const API_URL = environment.icRewardsApiEndPoint + "/api/reward/get_reward_list";
        // var params = {};
		// if (options != null && options["language"] != null)
		// 	params["language"] = options["language"];

        return this.http.post(API_URL, request, { headers: this.headers, /*params: params*/})
            .toPromise().then(response => (<BaseResponse<ICRewardsList>>response)).catch(error => { console.log(error); return error});
    }

    async redeemReward(request/*,  options?:{language?: string}*/) {
        const API_URL = environment.icRewardsApiEndPoint + "/api/reward/redeem_reward";
        var params = {};
		// if (options != null && options["language"] != null)
		// 	params["language"] = options["language"];

        return this.http.post(API_URL, request, { headers: this.headers, /*params: params*/})
            .toPromise().then(response => (<BaseResponse<RedeemReward>>response)).catch(error => { console.log(error); return error});
    }
}